import { FC } from 'react';

import { SkeletonBuilder } from '@telialt/common-skeleton-builder/src/SkeletonBuilder';
import { getPurpurSpacing } from '@telialt/common-theme/src/purpurSelectors';

import {
    FeaturesContainer,
    ProductColumn,
    ProductSkeleton,
    ProductsRow,
    SpacerColumn,
} from './ComparisonTableSkeleton.styles';

export const ComparisonTableSkeleton: FC = () => {
    return (
        <div>
            <ProductsRow>
                <SpacerColumn />
                <ProductColumn>
                    <ProductSkeleton />
                </ProductColumn>
                <ProductColumn>
                    <ProductSkeleton />
                </ProductColumn>
                <ProductColumn>
                    <ProductSkeleton />
                </ProductColumn>
            </ProductsRow>
            <FeaturesContainer>
                <SkeletonBuilder
                    baseHeight={3.5}
                    gap={getPurpurSpacing('50')}
                    config={[
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                        [{ height: 1, widthProportion: 1 }],
                    ]}
                />
            </FeaturesContainer>
        </div>
    );
};
